import React from "react";
import getAxios from "../../hooks/useAxios";
import { useSearchParams } from "react-router-dom";
import RideCard from "../../components/RideCard";
import { Box, Flex, Text, useTheme, Image, SimpleGrid } from "@chakra-ui/react";
import { Theme } from "../../theme";
import Cookies from "js-cookie";
import { StatCard, StatsType } from "../Revenue";

const RideHistory = () => {
  const axios = getAxios();
  const percentage = 15;
  const theme = useTheme<Theme>();
  let [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const access_token = Cookies.get("x-admin-auth");
  const [rideHistory, setRideHistory] = React.useState<any>();
  // const [todaysEarnings, setTodaysEarnings] = React.useState<any>()
  const [totalEarnings, setTotalEarnings] = React.useState<any>();
  const [refechKey, setRefechKey] = React.useState<any>("initial");
  const [ratings, setRatings] = React.useState<any>();
  const [ratingAll, setRatingAll] = React.useState<any>();
  const [stats, setStats] = React.useState<StatsType>();
  const [isTodaysDataFetching, setIsTodaysDataFetching] = React.useState(true);

  const getDriverEarnings = async () => {
    setIsTodaysDataFetching(true);
    try {
      const res = await axios.get(`/incomes/summary?driver_id=${id}`, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      });
      console.log("all stats", res.data);
      setStats(res.data);
    } catch (error) {
      console.log("error fetching stats", error);
    } finally {
      setIsTodaysDataFetching(false);
    }
  };

  const getHistory = async () => {
    try {
      const res = await axios.get(`/rides?driver_id=${id}`);
      console.log("history", res.data);
      const filtered = res.data.data.filter(
        (item: any) => item.status !== "requested",
      );
      setRideHistory(filtered);
    } catch (error) {
      console.log("error ride history", error);
    }
  };

  async function getAllEarning() {
    try {
      const res = await axios.get(`/incomes?driver_id=${id}`);
      console.log("all earning", res.data);
      setTotalEarnings(res.data);
    } catch (error) {
      console.log("error incomes", error);
    }
  }

  // async function getDailyEarning() {
  //     try {
  //         const res = await axios.get(`/incomes/daily/all?driver_id=${id}`);
  //         console.log("daily", res.data[0]);
  //         setTodaysEarnings(res.data[0])
  //     } catch (error) {
  //         console.log("error daily", error);
  //     }
  // };

  async function handleMarkAsPaid() {
    try {
      const res = await axios.get(`/drivers/${id}/payments`);
      setRefechKey(`refetch_${Math.random()}`);
      return alert("Payment marked as paid!");
    } catch (error) {
      console.log("error in reseting", error);
    }
  }

  const getUserRatings = async () => {
    try {
      const res = await axios.get(`/ratings/drivers/${id}`);
      const totalRating = Number(res.data?.total_rating) || 0;
      const ratingCount = Number(res.data?.rating_count) || 0;
      const ratings = ratingCount > 0 ? totalRating / ratingCount : 0;
      setRatings(ratings);
    } catch (error) {
      console.log("error fetching ratings", error);
    }
  };

  const getUserRatingsAll = async () => {
    try {
      const res = await axios.get(`/ratings/drivers/${id}/all`);
      console.log("all ratings", res.data);
      setRatingAll(res.data);
    } catch (error) {
      console.log("error fetching ratings all", error);
    }
  };

  React.useEffect(() => {
    getAllEarning();
    // getDailyEarning();
    getDriverEarnings();
    getHistory();
    getUserRatings();
    getUserRatingsAll();
  }, [refechKey]);

  return (
    <Box sx={{ padding: "1rem" }}>
      <Flex sx={{ gap: "1rem" }}>
        <Box style={{ flex: 1 }}>
          <SimpleGrid
            columns={{ base: 2, md: 2, lg: 2 }}
            spacing={4}
            marginTop={4}
          >
            <StatCard
              title="Today's Details"
              rides={stats?.daily?.rides}
              amount={stats?.daily?.amount}
              loading={isTodaysDataFetching}
            />
            <StatCard
              title="This Week Details"
              rides={stats?.weekly?.rides}
              amount={stats?.weekly?.amount}
              loading={isTodaysDataFetching}
            />
            <StatCard
              title="This Month Details"
              rides={stats?.monthly?.rides}
              amount={stats?.monthly?.amount}
              loading={isTodaysDataFetching}
            />
            <StatCard
              title="Total Details"
              rides={stats?.total?.rides}
              amount={stats?.total?.amount}
              loading={isTodaysDataFetching}
            />
          </SimpleGrid>
        </Box>

        <Box
          bg="white"
          borderRadius="10px"
          border="1px solid"
          borderColor="gray.200"
          style={{
            width: "100%",
            margin: "1rem auto",
            boxShadow: "0px 0px 10px rgba(0,0,0,0.1)",
            borderRadius: "10px",
            flex: 1,
          }}
        >
          <Flex
            sx={{
              borderBottom: "1px solid",
              borderColor: theme.colors.divider,
              padding: "0.75rem 1.25rem",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Text sx={{ fontSize: "1.25rem", fontWeight: 900 }}>
              Billing Details
            </Text>
          </Flex>
          <Flex
            sx={{
              padding: "1.25rem",
            }}
          >
            <Box sx={{ flex: 1 }}>
              <Flex sx={{ gap: "0.5rem" }}>
                <Text sx={{ color: theme.colors.secondary.light }}>
                  Billing date:
                </Text>
                <Text sx={{ fontWeight: 600 }}>
                  {totalEarnings?.current_start &&
                    new Date(totalEarnings?.current_start).toDateString()}
                </Text>
              </Flex>

              <Flex sx={{ gap: "0.5rem" }}>
                <Text sx={{ color: theme.colors.secondary.light }}>
                  Amount collected by driver:
                </Text>
                <Text sx={{ fontWeight: 600 }}>
                  ₹
                  {(totalEarnings?.current_income &&
                    totalEarnings.current_income.toFixed(2)) ||
                    0}
                </Text>
              </Flex>
              <Flex sx={{ gap: "0.5rem" }}>
                <Text sx={{ color: theme.colors.secondary.light }}>
                  Amount to be paid to Zippy:
                </Text>
                <Text sx={{ fontWeight: 600 }}>
                  ₹
                  {(totalEarnings?.current_income &&
                    (
                      (percentage / 100) *
                      totalEarnings?.current_income
                    ).toFixed(2)) ||
                    0}
                </Text>
              </Flex>
              <Flex sx={{ gap: "0.5rem" }}>
                <Text sx={{ color: theme.colors.secondary.light }}>
                  Payment due on:
                </Text>
                <Text sx={{ fontWeight: 600 }}>
                  {totalEarnings?.current_end &&
                    new Date(totalEarnings?.current_end).toDateString()}
                </Text>
              </Flex>

              <Box
                sx={{
                  padding: "1.25rem 0",
                  marginTop: "1.25rem",
                }}
              >
                <Box
                  sx={{
                    padding: "0.5rem 1rem",
                    cursor: "pointer",
                    width: "max-content",
                    border: "1px solid",
                    borderColor: theme.colors.primary.main,
                    borderRadius: "0.5rem",
                  }}
                  onClick={() => {
                    handleMarkAsPaid();
                  }}
                >
                  <Text
                    sx={{
                      fontSize: "1rem",
                      fontWeight: 900,
                      color: theme.colors.primary.main,
                    }}
                  >
                    Mark As Paid
                  </Text>
                </Box>
              </Box>
            </Box>
          </Flex>
        </Box>
      </Flex>

      <Flex sx={{ gap: "1rem" }}>
        <Box
          bg="white"
          borderRadius="10px"
          border="1px solid"
          borderColor="gray.200"
          style={{
            flex: 1,
            width: "100%",
            maxWidth: "40rem",
            marginTop: "1rem",
            boxShadow: "0px 0px 10px rgba(0,0,0,0.1)",
            borderRadius: "10px",
            height: "max-content",
          }}
        >
          <Flex
            sx={{
              borderBottom: "1px solid",
              borderColor: theme.colors.divider,
              padding: "0.75rem 1.25rem",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Text sx={{ fontSize: "1.25rem", fontWeight: 900 }}>
              Ride History
            </Text>
          </Flex>
          <Box
            sx={{
              padding: "1.25rem",
            }}
          >
            {rideHistory &&
              rideHistory?.map((item: any, index: number) => {
                return <RideCard key={index} item={item} />;
              })}
          </Box>
        </Box>

        <Box
          bg="white"
          borderRadius="10px"
          border="1px solid"
          borderColor="gray.200"
          style={{
            flex: 1,
            width: "100%",
            height: "max-content",
            marginTop: "1rem",
            boxShadow: "0px 0px 10px rgba(0,0,0,0.1)",
            borderRadius: "10px",
          }}
        >
          <Flex
            sx={{
              borderBottom: "1px solid",
              borderColor: theme.colors.divider,
              padding: "0.75rem 1.25rem",
              alignItems: "center",
              gap: "1rem",
            }}
          >
            <Text sx={{ fontSize: "1.25rem", fontWeight: 900 }}>
              Driver Ratings and Comments
            </Text>
            <Flex alignItems={"center"} justifyContent={"center"}>
              <Text sx={{ fontSize: "1.25rem", fontWeight: 900 }}>
                {ratings?.toFixed(1) || 0.0}
              </Text>
              <Image
                src={"/StarFilled.png"}
                alt="No Images"
                aspectRatio={1 / 1}
                width="1.5rem"
              />
            </Flex>
          </Flex>
          <Box
            sx={{
              padding: "1.25rem",
            }}
          >
            <Text
              sx={{
                color: theme.colors.secondary.light,
                marginBottom: "0.5rem",
              }}
            >
              Showing 90 days ratings and comments
            </Text>
            {ratingAll &&
              ratingAll?.map((item: any, index: number) => {
                return (
                  <Box
                    sx={{
                      gap: "0.5rem",
                      border: "1px solid",
                      borderColor: theme.colors.divider,
                      marginBottom: "1rem",
                      padding: "1rem",
                      borderRadius: "0.5rem",
                    }}
                    key={index}
                  >
                    <Flex sx={{ gap: "0.5rem" }}>
                      <Text sx={{ color: theme.colors.secondary.light }}>
                        Ratings:
                      </Text>
                      <Flex alignItems={"center"} justifyContent={"center"}>
                        <Text sx={{ fontWeight: 600 }}>
                          {item?.rating || 0.0}
                        </Text>
                        <Image
                          src={"/StarFilled.png"}
                          alt="No Images"
                          aspectRatio={1 / 1}
                          width="1.3rem"
                        />
                      </Flex>
                    </Flex>

                    <Flex sx={{ gap: "0.5rem" }}>
                      <Text sx={{ color: theme.colors.secondary.light }}>
                        Comments:
                      </Text>
                      <Text sx={{ fontWeight: 600 }}>
                        {item?.comment || "-----------"}
                      </Text>
                    </Flex>
                    {/* <Text sx={{ color: theme.colors.secondary.light }}>
                                    Comments: {item?.comment || "----"}
                                  </Text> */}
                  </Box>
                );
              })}
          </Box>
        </Box>
      </Flex>
    </Box>
  );
};

export default RideHistory;
